import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';
import ImageUploadField from '../components/ImageUploadField';

function SpeakersPage() {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ eventId: '', name: '', email: '', profile: '', description: '', fotoUrl: '' });

  const load = async () => {
    try {
      const [s, e] = await Promise.all([api.get(endpoints.speakers(), token), api.get(endpoints.events(), token)]);
      setData(s);
      setEvents(e);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(endpoints.speaker(editing.id), form, token);
      else await api.post(endpoints.speakers(), form, token);
      setModalOpen(false);
      setEditing(null);
      setForm({ eventId: '', name: '', email: '', profile: '', description: '', fotoUrl: '' });
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm('¿Eliminar ponente?')) return;
    try {
      await api.delete(endpoints.speaker(row.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Nombre' },
    { key: 'email', label: 'Email' },
    { key: 'profile', label: 'Perfil / Especialidad' },
    { key: 'fotoUrl', label: 'Foto URL', render: (val) => val ? <a href={val} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline truncate block max-w-[120px]">Ver</a> : '—' },
    { key: 'eventId', label: 'Evento' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Ponentes</h1>
        <button onClick={() => { setEditing(null); setForm({ eventId: events[0]?.id || '', name: '', email: '', profile: '', description: '', fotoUrl: '' }); setModalOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nuevo ponente</button>
      </div>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={data} onEdit={(r) => { setEditing(r); setForm(r); setModalOpen(true); }} onDelete={handleDelete} />}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar ponente' : 'Nuevo ponente'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div><label className="block text-sm font-medium mb-1">Evento</label><select value={form.eventId} onChange={(e) => setForm((f) => ({ ...f, eventId: e.target.value }))} className="w-full px-3 py-2 border rounded">{events.map((ev) => <option key={ev.id} value={ev.id}>{ev.nombre}</option>)}</select></div>
          <div><label className="block text-sm font-medium mb-1">Nombre</label><input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="w-full px-3 py-2 border rounded" required /></div>
          <div><label className="block text-sm font-medium mb-1">Email</label><input type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <div><label className="block text-sm font-medium mb-1">Perfil / Especialidad</label><input value={form.profile} onChange={(e) => setForm((f) => ({ ...f, profile: e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <ImageUploadField label="Foto URL" value={form.fotoUrl || ''} onChange={(v) => setForm((f) => ({ ...f, fotoUrl: v }))} token={token} />
          <div><label className="block text-sm font-medium mb-1">Descripción</label><textarea value={form.description || ''} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} className="w-full px-3 py-2 border rounded" rows={3} /></div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Guardar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default SpeakersPage;
